import { useRef, useState } from 'react';

import { useDispatch } from 'react-redux';

import { Dialog, DialogTitle, DialogContent, Box, Button, Typography } from '@mui/material';

import WhatsAppIcon from '@mui/icons-material/WhatsApp';

import { setPhoneNumber } from '../store/slices/WhatsAppNotificationSlice';

import { Teclado } from '../components/Teclado';

interface Props {
    open:           boolean;
    onClose:        () => void;
    onReset:        () => void;
}

type AccessMode = 'select' | 'whatsapp';

export const DialogAcceso = ( { open, onClose, onReset } : Props ) => {

    const dispatch = useDispatch();

    const audioRef = useRef<HTMLAudioElement>(new Audio( process.env.PUBLIC_URL + "/assets/click.wav" ));

    const timeoutRef = useRef<number | null>( null );

    const [mode, setMode] = useState<AccessMode>( 'select' );

    const sound = () => {

        audioRef.current.pause();
        audioRef.current.currentTime = 0;
        audioRef.current.play();
        
    }

    const resetState = () => { 

        setMode( 'select' ); 

        if ( timeoutRef.current ) {
            window.clearTimeout( timeoutRef.current );
        }

    }

    const resetTimer = () => {

        if ( timeoutRef.current ) {
            window.clearTimeout( timeoutRef.current );
        }

        timeoutRef.current = window.setTimeout( () => {

            resetState();

        }, 6000);

    }

    const handleSignInWhatsApp = () =>{

        sound(); 
        resetTimer(); 
        setMode( 'whatsapp' );
        
        dispatch( setPhoneNumber({ phoneNumber: '' }) );

    }

    const handleSingInGuest = () => {

        sound(); 
        onClose(); 
        resetTimer();
        onReset();

        dispatch( setPhoneNumber({ phoneNumber: '' }) );

    }

    return (

        <Dialog 
            disableEscapeKeyDown 
            fullWidth
            maxWidth={ mode === 'whatsapp' ? 'sm' : 'sm' }
            open={ open }
            onClose={ () => {} }    
            onClick={ resetTimer }
            onTouchStart={ resetTimer }
        >

            <DialogTitle align='center' sx={{ fontSize: 32 }}>
                {
                    mode === 'whatsapp' ? 'Ingresa con WhatsApp' : 'Acceso al sistema'
                }                
            </DialogTitle>

            <DialogContent
                sx={{
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                }}
            >              

                {
                    mode === 'select' 
                    && 
                        <Box display='flex' flexDirection='column' gap={4}>

                            <Typography variant='h6' align='center' fontWeight={'normal'}>
                                Seleccione una opción para continuar
                            </Typography>

                            <Button
                                fullWidth
                                variant='contained'
                                color='success'
                                startIcon={
                                    <WhatsAppIcon
                                        sx={{
                                            fontSize: 28,
                                            "&.MuiSvgIcon-root": {
                                                fontSize: 28,
                                            },
                                        }}
                                    />
                                }
                                sx={{
                                    py: 2,
                                    fontSize: 20,
                                    borderRadius: 2,                                  
                                }}
                                onClick={ handleSignInWhatsApp }
                            >
                                Ingresar con WhatsApp
                            </Button>

                            <Typography variant='caption' textAlign={'justify'}>
                                Ingrese con su número de teléfono celular si cuenta con <strong>WhatsApp</strong> y tiene su dispositivo disponible en este momento.
                                <br /> <br /> Si no cumple con esta condición, seleccione la opción <strong>Ingresar como invitado</strong>.
                            </Typography>

                            <Button
                                fullWidth
                                sx={{
                                    py: 2,
                                    fontSize: 20,
                                    borderRadius: 2,
                                }}
                                onClick={ handleSingInGuest }
                            >
                                Ingresar como invitado
                            </Button>

                        </Box>                    
                }

                {
                    mode === 'whatsapp' 
                    && 
                        <Teclado 
                            onBack={ resetState } 
                            onActivity={ resetTimer }
                            onSignIn={ onClose }
                        />                
                }                

            </DialogContent>

        </Dialog>

    );
};
